// extracted by mini-css-extract-plugin
export default {"page":"styles_page__5HKYG","leftPanel":"styles_leftPanel__bu58s","rightPanel":"styles_rightPanel__4BCtp","form":"styles_form__TEgcG","footerError":"styles_footerError__Z6Bdb"};